/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Send_SuccessInputs */

const en_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent!`)
};

const ar_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الإرسال!`)
};

const bn_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানো হয়েছে!`)
};

const de_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendet!`)
};

const es_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Enviado!`)
};

const fr_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyé !`)
};

const pt_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado!`)
};

const zh_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发送！`)
};

const tr_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderildi!`)
};

const ru_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлено!`)
};

const pl_form_send_success = /** @type {(inputs: Form_Send_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłano!`)
};

/**
* | output |
* | --- |
* | "Sent!" |
*
* @param {Form_Send_SuccessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_send_success = /** @type {((inputs?: Form_Send_SuccessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Send_SuccessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_send_success(inputs)
	if (locale === "bn") return bn_form_send_success(inputs)
	if (locale === "de") return de_form_send_success(inputs)
	if (locale === "es") return es_form_send_success(inputs)
	if (locale === "fr") return fr_form_send_success(inputs)
	if (locale === "pt") return pt_form_send_success(inputs)
	if (locale === "zh") return zh_form_send_success(inputs)
	if (locale === "tr") return tr_form_send_success(inputs)
	if (locale === "ru") return ru_form_send_success(inputs)
	if (locale === "pl") return pl_form_send_success(inputs)
	return en_form_send_success(inputs)
});